import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  standalone: false,
  template: `
    <app-header></app-header>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
    <a href="#top" class="back-to-top d-flex align-items-center justify-content-center" [class.active]="showBackToTop" (click)="scrollTop($event)">
      <i class="bi bi-arrow-up-short"></i>
    </a>
  `
})
export class AppComponent {
  showBackToTop = true;

  scrollTop(event: Event): void {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
